import { Custom } from 'amo-styling-library'

// LDH Trans custom theme configuration
// Overrides amo-styling-library defaults with LDH brand colors and typography
export const ldhTheme: Custom = {
  palette: {
    primary: {
      lighter: '#FFE5E8',
      light: '#FEA3A3',
      main: '#DA0000',
      dark: '#B80000',
      darker: '#960000'
    },
    black: {
      offBlack: '#2D2C3C',
      main: '#000000'
    },
    white: {
      offWhite: '#F9FAFF',
      main: '#FFFFFF'
    },
    gray: {
      lighter: '#F6F6F6',
      light: '#EEEEEE',
      main: '#888888',
      dark: '#5D5D5D',
      darker: '#443F3F'
    }
  },
  typography: {
    fontFamily: '"Montserrat", "Karla", sans-serif'
  }
}
